import React, { useEffect, useState } from 'react'
import request from '../../../../utils/request';
import AnimalListItem from './AnimalListItem';
import { Box, IconButton, Menu, MenuItem, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { selectDataListSectionIds, selectEndorsmentScreenNumber } from 'src/features/rfqDataSlice';
import { Settings } from "@mui/icons-material";
import AddNewHeaderBox from '../AddNewHeaderBox';
function AnimalList({ sumInsuredData, productId }) {
  const [fetchLoader, setFetchLoader] = useState(null);
  const [empGroups, setEmpGroups] = useState([]);
  const endorsementScreenNumber = useSelector(selectEndorsmentScreenNumber);
  const [openAddNewHeaderBox,setOpenAddNewHeaderBox]=useState(false);  
  const [anchorEl, setAnchorEl] = useState(null);
  const closeAddNewHeaderBox =()=>{
    setOpenAddNewHeaderBox(false);
  }
  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  useEffect(() => {
    fetchEmpGroups();
  }, [])

  const fetchEmpGroups = () => {
    setFetchLoader(true);
    request({
      url: '/insurancePolicy/getSumInsuredListGroups',
      method: 'post',
      data: {
        policyId: sumInsuredData.policyId,
        sectionId: sumInsuredData.id
      }
    }).then(
      (response: any) => {
        setFetchLoader(false);
        setEmpGroups(response.data);
        if (response.data.length > 0) {
          let sumInsuredBox = document.getElementById('sumInsuredBox');
          if (sumInsuredBox) { sumInsuredBox.style.display = 'block' }
        }
      },
      (error) => {
        console.log(error);
        setFetchLoader(false);
      }
    );
  }



  return (
    <>
      {empGroups.length > 0 &&
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          sx={{
            mt: "10px",
            mb: "5px",
            p: "6px",
            background: "rgb(9, 84, 174)",
            color: "#fff",
            borderRadius: "4px",
          }}
        >
          <Typography
            gutterBottom
            variant="h5"
            className="heading"
            component="div"
            sx={{ fontWeight: "bold" }}
          >
            {sumInsuredData?.sectionName}
          </Typography>
          {endorsementScreenNumber == 1 && <>
            <IconButton onClick={handleOpenMenu} sx={{ color: "#fff", padding: 0 }}>
              <Settings />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleCloseMenu}
            >
              <MenuItem
                  key={'add_headers'}
                  onClick={() => {
                    setOpenAddNewHeaderBox(true);
                    handleCloseMenu();
                  }}
                >
                 Add Headers
                </MenuItem>
            </Menu>
          </>}


        </Box>

      }



      {empGroups.length > 0 &&
        empGroups.map((group) => (
          <AnimalListItem
            key={group.id}
            sumInsuredData={sumInsuredData}
            groupDetails={group}
            policyId={sumInsuredData.policyId}
            productId={productId}
          />
        ))
      }

      {openAddNewHeaderBox &&   <AddNewHeaderBox  sumInsuredData={sumInsuredData} onClose={closeAddNewHeaderBox}/>}
     

    </>
  )
}

export default AnimalList